import React from 'react';
import { IconButton, Stack, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setGridView } from "../../../../../redux/SearchSlice";
import { localStorageInstance } from "../../../../../utils/localStorage";
import { TooltipName } from "../../../../../utils/Enums";
import gridActiveIcon from "../../../../../styles/svg/grid-view-active.svg";
import gridInactiveIcon from "../../../../../styles/svg/grid-view-inactive.svg";
import listActiveIcon from "../../../../../styles/svg/list-view-active.svg";
import listInactiveIcon from "../../../../../styles/svg/list-view-inactive.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const ViewToggle = ({ setLoading, setParamsWorklogs, searchParams, setSearchParams }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const gridView = useSelector((state) => state.search.gridView);
  const paramsWorklogs = searchParams.get("worklogs") || "false";

  return (
    <Stack className="grid-list-cont">
      <Tooltip title={TooltipName.KANBAN_VIEW}>
        <IconButton
          aria-label="grid-view"
          className="board-header-grid-icon"
        >
          <img
            src={gridView && paramsWorklogs === "false" && location.pathname.includes("/board/") ? gridActiveIcon : gridInactiveIcon}
            alt="gridIcon"
            onClick={() => {
              const newSearchParams = new URLSearchParams(searchParams);
              newSearchParams.delete("workflow_Step");
              setSearchParams(newSearchParams);
              if (!gridView) {
                dispatch(setGridView());
              }
              setParamsWorklogs("worklogs", "false");
              localStorageInstance.setItem({
                key: "showGridView",
                value: true,
              });
              if (!location.pathname.includes("/board/")) {
                const currentSearch = searchParams.toString();
                navigate(`/board/${id}?${currentSearch ? `&${currentSearch}` : ""}`);
                return;
              }
            }}
          />
        </IconButton>
      </Tooltip>
      <Tooltip title={TooltipName.LIST_VIEW}>
        <IconButton
          aria-label="list-view"
          className="board-header-list-icon"
          sx={{ borderLeft: "1px solid rgba(145, 158, 171, 0.2)" }}
        >
          <img
            src={!gridView && paramsWorklogs === "false" && location.pathname.includes("/board/") ? listActiveIcon : listInactiveIcon}
            alt="listIcon"
            onClick={() => {
              if (gridView) {
                dispatch(setGridView());
              }
              setLoading();
              setParamsWorklogs("worklogs", "false");
              localStorageInstance.setItem({
                key: "showGridView",
                value: false,
              });
              if (!location.pathname.includes("/board/")) {
                const currentSearch = searchParams.toString();
                navigate(`/board/${id}?${currentSearch ? `&${currentSearch}` : ""}`)
                return;
              }
            }}
          />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

export default ViewToggle; 